module.exports = __webpack_public_path__ + "static/media/28DGC1.ddf8f589.jpg";